import {EInterceptionObserver} from "../EIntersectionObserver/EIntersectionObserver";

import './bolsHoyImages.scss';
import 'swiper/swiper-bundle.css';
import {sendPush} from "../../marketing/gtm";

export const bolsaHoyImagesSlider = () => {
    const element = document.querySelector('.bolsaDirectoImage__container');

    EInterceptionObserver([element], async (target) => {
        const {Swiper, Navigation, Pagination} = await import('swiper');
        Swiper.use([Navigation, Pagination]);

        sendPush({
            'event' : 'web-vitals',
            'event_category' : 'homeLiveStockImageModule',
            'event_action' : 'loaded'
        }, null);

        const swiper = new Swiper(target, {
            slidesPerView: 1,
            spaceBetween: 10,
            cssMode: true,
            mousewheel: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            }
        });

        swiper.on('slideChange', function (e) {
            sendPush({
                'event' : 'web-vitals',
                'event_category' : 'homeLiveStockImageModule',
                'event_action' : 'change'
            }, null);
        });
    });

}